/* eslint-disable */
import axios from "axios";
import { urlCoreBack } from "../../project/configs/config";
import "../utils/axios.interceptor";

const epName = "v1/factura/";
const epName1 = "v1/retry-factura/";
const nameItemsText = "Facturas";
const nameItemText = "Factura";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const saveFactura = async (actionCrud, parFactura) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;

  parFactura.id_area = localStorage.getItem("id_area_ventas");
  parFactura.id_usuario = localStorage.getItem("id_usuario");

  try {
    let response = {};
    if (actionCrud === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epName}`,
        data: parFactura,
      });
    } else if (actionCrud === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epName}`,
        data: cobranza,
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText =
          `${nameItemText}` +
          (actionCrud === "disable"
            ? itemGender === "M"
              ? " deshabilitado"
              : " deshabilitada"
            : actionCrud === "enable"
              ? itemGender === "M"
                ? " habilitado"
                : " habilitada"
              : itemGender === "M"
                ? " guardado"
                : " guardada");
        response.messageSeverity = "success";
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);

        let _message_code = response.data.code;
        if (_message_code === "err-comprobante-venta-cobranza-facturada-not-allowed") {
          response.messageText =
            "No es posible registrar esta Factura ya que la Cobranza se encuentra actualmente facturada";
        } else if (_message_code === "err-comprobante-venta-cobranza-odoo-error") {
          response.messageText =
            "No fue posible registrar esta Factura en el sistema Odoo. Reintente más tarde";
        } else {
          response.messageText = _errorMessage;
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getFactura = async (idFactura) => {
  let _errorMessage = "Se produjo un error al obtener la Cobranza";

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/factura/`,
      params: { id: idFactura },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const retryFacturaOdoo = async (idFactura) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText} en el sistema Odoo`;

  console.log('---');
  console.log('in retryFacturaOdoo');
  console.log('idFactura');
  console.log(idFactura);
  console.log();

  try {
    let response = {};
    response = await axios({
      method: "PUT",
      url: `${urlCoreBack}${epName1}`,
      data: { id: idFactura },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `${nameItemText}` + " guardada";
        response.messageSeverity = "success";
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);

        let _message_code = response.data.code;
        if (_message_code === "err-comprobante-venta-cobranza-facturada-not-allowed") {
          response.messageText =
            "No es posible registrar esta Factura ya que la Cobranza se encuentra actualmente facturada";
        } else if (_message_code === "err-comprobante-venta-cobranza-odoo-error") {
          response.messageText =
            "No fue posible registrar esta Factura en el sistema Odoo. Por favor Reintentá más tarde";
        } else {
          response.messageText = _errorMessage;
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};